import "../../stylesheets/about-package/about.less";

import {t} from "@lingui/core/macro";
import * as React from "react";

import {
    withActionScheduler,
    type WithActionSchedulerProps,
    type WithoutActionScheduler,
} from "@khanacademy/wonder-blocks-timing";

import PageRoot from "#app-shell-package/page-root.tsx";

import AboutHeader from "./about-header.tsx";
import AboutNav from "./about-nav.tsx";
import BoardPage from "./board-page.tsx";
import getLeadershipData from "./leadership-data.tsx";
import {withStrings} from "./locales/our-board/load-strings.tsx";

type OwnProps = Empty;
type Props = OwnProps & WithActionSchedulerProps;

class AboutOurBoard extends React.Component<Props> {
    defaultSearchBarPosition: unknown;

    render(): React.ReactNode {
        return (
            <PageRoot settings={{title: t`About Our Leadership Team`}}>
                <div className="about-page">
                    <AboutHeader pageheadline={t`Meet our leadership team`} />
                    <AboutNav aboutSelection="our-board" />
                    <div id="the-team">
                        <BoardPage sections={getLeadershipData()} />,
                    </div>
                </div>
            </PageRoot>
        );
    }
}

type ExportProps = WithoutActionScheduler<
    JSX.LibraryManagedAttributes<
        typeof AboutOurBoard,
        React.ComponentProps<typeof AboutOurBoard>
    >
>;
export default withStrings(
    withActionScheduler(AboutOurBoard) as React.ComponentType<ExportProps>,
);
